
<template>  
  <div class="grid masterAppPanel">

    <div v-if="isAuthenticated" class="mainMenu p-menubar p-component col-12" data-pc-name="menubar" data-pc-section="root">
     <img
          alt="logo"
          src="@/assets/logo-biomedica-laboratorija.png"
          class="p-mr-2 biomedicalogo"
          @click="onLogoClick" />

      <div class="menuRight" v-if="!isMobile">
        <div class="menuButtons">
          <Button
            icon="pi pi-user"
            severity="contrast" plain text  
            :label=profileString
            @click="this.$router.push({ name: 'Profile' })">
          </Button>

          <Button
            icon="pi pi-user"
            severity="contrast" plain text  
            :label=dashboardString
            @click="this.$router.push({ name: 'Dashboard' })">
          </Button>

          <Button
            icon="pi pi-power-off"
            class="p-button-raised p-button-rounded p-button-warning powerOffButton"
            @click="onLogout">
          </Button>   
        </div>
        <div class="usernamerow">
          <div>{{ userNameSurname }}</div>
        </div>
      </div>

      <div class="mobilemenu mobileview" v-if="isMobile">
        <div class="usernamerow">
          <div>{{ userNameSurname }}</div>
        </div>
        <div class="menuRight">
          <div class="hamburger" @click="toggleMenu">
            <i class="pi pi-bars" style="font-size: 1.4rem"></i>
          </div>
          <div class="menuButtons" v-if="isMobile" v-show="menuOpen">
            <Button
              icon="pi pi-user"
              severity="contrast" plain text  
              :label=profileString
              @click="this.menuOpen=false;this.$router.push({ name: 'Profile' })">
            </Button>

            <Button
              icon="pi pi-user"
              severity="contrast" plain text  
              :label=dashboardString
              @click="this.menuOpen=false;this.$router.push({ name: 'Dashboard' })">
            </Button>

            <Button
              icon="pi pi-power-off"
              label="ODJAVA"
              class="p-button-warning"
              @click="onLogout">
            </Button>   

          </div>             
        </div>
      </div>        
    </div>   
  </div>
<!-- 

    <Menubar :model="items" v-if="isAuthenticated" class="col-12">
      <template #start>
        <img
          alt="logo"
          src="@/assets/logo-biomedica-laboratorija.png"
          class="p-mr-2 biomedicalogo"
          @click="onLogoClick" />
      </template>

      <template #item="{ item }">

        <Button
          :icon="item.icon"
          severity="contrast" plain text  
          :label="item.label"
          @click="this.$router.push({ name: item.destination })">
        </Button>

      </template>


      <template #end>


        <Button
          icon="pi pi-power-off"
          class="p-button-raised p-button-rounded p-button-warning"
          @click="onLogout"></Button>
      </template>
    </Menubar>     
  </div>
-->
  <router-view /> 
  
  <div class="col-12">
    <div class="grid footercontentbiomedica">
      <div class="col-12">© {{ new Date().getFullYear() }} BioMedica</div>
      <div class="col-12">developed by <a src="https://www.olivebox.net">olivebox.net</a></div>
    </div>
  </div>
</template>


<script>
import store from "@/store";
import { computed } from "vue";
import { ref } from "vue";
import { useRouter } from 'vue-router';

// import router from "./router";
//import AppTopBar from "./AppTopbar.vue";

export default {
  data() {
    return {
      isMobile: false,
      menuOpen: false,   
    }
  },
  setup() {

    const router = useRouter();

    debugger;
    store.dispatch("InitMyStore");
    store.commit("initialiseStore");

    debugger;
    // console.log("KONEC INIT");

    // const items = ref([
    //   {
    //     label: "Nadzorna ploča",
    //     icon: "pi pi-fw pi-chart-bar",
    //     command: () => {
    //         // router.push({ name: "Dashboard" });
    //         router.push({ name: "Dashboard" });
    //         // this.$router.push({ name: "Dashboard" });
    //     },
    //     destination: "Dashboard",
    //     // to: "/",
    //     visible: () => store.getters.isAuthenticated,
    //   },
    //   {
    //     label: "Profil",
    //     icon: "pi pi-user",
    //     // to: "/profile",
    //     command: () => {
    //       // // console.log("PROFIL");
    //         // router.push('/profile');
    //         router.push({ name: "Profile" });
    //         // this.$router.push({ name: "Profile" });
    //     },
    //     destination: "Profile",
    //     visible: () => store.getters.isAuthenticated,
    //   },
    // ]);

    return {
      /*
        computed : {
          isAuthenticated : function() { return true;
            // console.log('PRISEL V AUTH');
            let au = this.$store.getters.isAuthenticated;
            // console.log('Auth:' + au);
            return au;
          }
        }, */
      translated: computed(() => store.getters.getTranslate),
      isBusy: computed(() => store.state.isBusy),
      error: computed(() => store.state.error),
      isAuthenticated: computed(() => store.getters.isAuthenticated),
      dashboardString: computed(() => store.getters.getTranslate("dashboard")),
      profileString: computed(() => store.getters.getTranslate("profil")),
      userNameSurname: computed(() => store.state.userNameSurname),   
      onLogout() {
        // console.log("onLogout");
        store.dispatch("logout");
        // router.push({ name: 'Login' })
      },
      onLogoClick() {
        // console.log("onLogoClick");
        router.push({ name: "Dashboard" });
      },
      // items: items,
    };
  },
  beforeCreate: function () {
    // console.log(
//      "beforeCreate APP . VUE ==================================================================================="
    // );
  },
  mounted: function () {
    // console.log(
    //   "mounted APP. VUE ==================================================================================="
    // );
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.handleResize);

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  beforeUpdate: function () {
    
    debugger; 

    let tmpDash = store.getters.getTranslate("pocetnastrana");
    let tmpProfile = store.getters.getTranslate("profil");

    this.items = ref([
      {
        label: tmpDash,
        icon: "pi pi-fw pi-chart-bar",
        to: "/",
        visible: () => store.getters.isAuthenticated,
      },
      {
        label: tmpProfile,
        icon: "pi pi-user",
        to: "/profile",
        visible: () => store.getters.isAuthenticated,
      },
    ]);
  },
  //computed: {
  /*
      getMyTranslate(key) {
        // console.log('PRIŠEL V getMyTranslate!!!!!!!!!!!!!!!!!!!!!!');
          return store.getters.getTranslate(key)
        }
        */
  //},
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleResize() {
      // console.log("handleResize");
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.menuOpen = false; // Close menu when switching to larger screen
      }
    },
    onWrapperClick() {
      // console.log("onWrapperClick");
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      // console.log("MENU TOGGLE");
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }
          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }
      event.preventDefault();
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
  },
  // components: {
  //   AppTopBar: AppTopBar,
  // },
};
</script>

<style lang="scss">
@import "./App.scss";

body {
  overflow-y: scroll;
}

body.p-overflow-hidden {
  padding-right: 16px;
}

#app {
  max-width: 1024px;
  margin: 0 auto;
  padding-left: 5px;
  padding-right: 5px;
}

span.p-menuitem-text {
  color: whitesmoke !important;
}

span.p-menuitem-icon {
  color: whitesmoke !important;
}

.p-menubar.p-component {
  background: #f2f2f2;
  height: 95px;
}

li.p-menuitem span {
    color: #495057!important;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:focus {
  box-shadow: initial !important;
}

.globalDialog .p-dialog-header {
  height: 40px;
  border-bottom: 1px solid darkgray;
  //padding: 1.9rem 1.5rem 1.1rem 1.5rem;
}

.p-dialog-header h4 {
  margin-bottom: initial;
}

li.p-menuitem.p-menuitem-active a:hover {
  background: #3f535d !important;
}

.p-menubar
  .p-menubar-root-list
  > .p-menuitem
  > .p-menuitem-link:not(.p-disabled):hover {
  background: #607d8b !important;
}

li.p-menuitem.p-menuitem-active a {
  background: #607d8b !important;
}

ul.p-submenu-list {
  background: #607d8b !important;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
    background: #607d8b29 !important;
}

.cardheader h5 {
  display: contents;
  font-weight: 500;
  margin: 3px 3px 3px 10px;
}

.cardheader {
  background: #ced4da;
  color: #224a23;
  padding: 3px 3px;
  height: 50px;
}

.logindiv {
  max-width: 400px;
  margin: 0 auto;
}

.logindiv .passdiv {
  margin-top: 30px;
}

.logindiv .errordiv {
  //height: 10px;
  padding-top: 40px;
  text-align: center;
}


.logindiv input {
  padding: 10px !important;
  // border: 0 !important;
  border-bottom: 1px solid #ddd !important;
  width: 100% !important;
  box-sizing: border-box !important;
}


.logindiv .p-password.p-component.p-inputwrapper {
  width: 100%;
}

ul.p-menubar-root-list {
    margin-left: auto !important;
}

.p-menubar .p-menubar-custom, .p-menubar .p-menubar-end {
    margin-left: initial !important; 
}

// .grid {margin-right: 0px !important;}

ul.p-menubar-root-list { margin-right: 10px !important; }

@media screen and (max-width: 960px) 
{ 
  .p-menubar .p-menubar-button { position: absolute;} 
  .p-menubar-start { left: calc( 50% - 95px ); position: relative; align-self: center; }
  .p-menubar-end { margin-left: auto; }

  .p-menubar .p-menubar-custom, .p-menubar .p-menubar-end { margin-left: auto !important; }
}

.p-dialog-header {
    background: #e9ecef !important;
    height: 20px;
}

.p-dialog-content {
    padding-top: 10px !important;
}

.p-d-flex {display: flex;}
.p-d-flex.searchPlaceholder > span {margin-left: auto;}

.p-menubar.p-component.col-12 {
    padding-right: 10px;
}

// .grid.masterAppPanel {
//     margin-right: 0!important;
// }

button {
    cursor: pointer;
}


.grid.footercontentbiomedica { text-align: center;margin-top: 20px;}
.grid.footercontentbiomedica div { padding: 0px;}

.p-menubar-start { cursor: pointer;}


.mainMenu {justify-content: space-between;align-items: center;}
.powerOffButton {margin-left: 20px;}

.usernamerow {color: #db878a; margin-right: 10px; padding-left: 15px;}
.usernamerow div {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}


.mobileview .menuButtons {position: absolute;top: 60px;right: 0px;display: flex;flex-direction: column;background: white;z-index: 999;}
.mobileview button span.p-button-label {text-align: left;}

.hamburger {
  display: none;
  cursor: pointer;
}


.mobilemenu {display: flex;flex-direction: row;}


/* Responsive adjustments */
@media (max-width: 768px) {  
  .hamburger {
    display: block; /* Show hamburger icon on small screens */
  }

  .menuButtons {
    // display: none; /* Hide buttons by default on small screens */
  }
}

</style>